/** Build-time configuration. */
import { DEFAULT_LEGACY_ORIGIN, siteUrl } from './site-url.ts';

export const API_URL: string = (import.meta.env.VITE_API_URL || 'http://localhost:3100').replace(/\/+$/, '');

/**
 * The public site (share links, og: tags): `VITE_SITE_URL`, else the default in
 * site-url.ts. The deployed site, not `location.origin`, so a result shared from
 * localhost or a preview still links somewhere a friend can play.
 */
export const SITE_URL: string = siteUrl(import.meta.env.VITE_SITE_URL);

/**
 * The old addresses (`VITE_LEGACY_ORIGINS`, comma-separated origins; default the
 * workers.dev one): a page there hands the player's data to SITE_URL (pwa/move.ts).
 */
export const LEGACY_ORIGINS_RAW: string = import.meta.env.VITE_LEGACY_ORIGINS ?? DEFAULT_LEGACY_ORIGIN;
